// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column--action {
  min-width: 112px;
  max-width: 112px;
  overflow: initial;
  justify-content: center;
}

.mat-mdc-header-cell,
.mat-mdc-cell {
  font-size: 14px;
}

.mobile-table-editor {
  width: 100%;
}

.mobile-table-editor-item {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  border-bottom: 1px solid #3e5777;
}

.mobile-table-editor-item .primary {
  grid-column: 1;
  grid-row: 1;
  margin: 8px 0 2px 0;
  font-size: 0.8em;
}

.mobile-table-editor-item .secondary {
  grid-column: 1;
  grid-row: 2;
  margin: 2px 0 8px 0;
  font-size: 0.8em;
  color: grey;
}

.mobile-table-editor-item .actions {
  grid-column: 2;
  grid-row: 1/3;
  display: flex;
  align-items: center;
  justify-content: right;
}

.mobile-empty-table {
  width: 100%;
  border-bottom: 1px solid #3e5777;
  display: flex;
  align-items: center;
  justify-content: right;
}

.mobile-empty-table p {
  flex: 1 1 auto;
}

.mobile-command-panel {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-command-panel .spacer {
  flex: 1 1 auto;
}

.ellipsis {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/table-editor/table-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;;EAEE,eAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,+BAAA;EACA,wBAAA;EACA,gCAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF","sourcesContent":[".mat-column--action {\n  min-width: 112px;\n  max-width: 112px;\n  overflow: initial;\n  justify-content: center;\n}\n\n.mat-mdc-header-cell,\n.mat-mdc-cell {\n  font-size: 14px;\n}\n\n.mobile-table-editor {\n  width: 100%;\n}\n\n.mobile-table-editor-item {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto;\n  border-bottom: 1px solid #3e5777;\n}\n\n.mobile-table-editor-item .primary {\n  grid-column: 1;\n  grid-row: 1;\n  margin: 8px 0 2px 0;\n  font-size: 0.8em;\n}\n\n.mobile-table-editor-item .secondary {\n  grid-column: 1;\n  grid-row: 2;\n  margin: 2px 0 8px 0;\n  font-size: 0.8em;\n  color: grey;\n}\n\n.mobile-table-editor-item .actions {\n  grid-column: 2;\n  grid-row: 1/3;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n}\n\n.mobile-empty-table {\n  width: 100%;\n  border-bottom: 1px solid #3e5777;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n}\n\n.mobile-empty-table p {\n  flex: 1 1 auto;\n}\n\n.mobile-command-panel {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mobile-command-panel .spacer {\n  flex: 1 1 auto;\n}\n\n.ellipsis {\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
